import React, { useState } from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';

import VideoModal from 'components/modals/VideoModal';

const Success = ({ t }) => {
  const [videoUrl, setVideoUrl] = useState('');

  return (
    <>
      <main className="has-header">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-15 col-sm-6">
              <div className="row mb-5">
                <div className="col text-center">
                  <div className="sign sign--success">
                    <i className="fa-solid fa-check" />
                  </div>
                </div>
              </div>
              <div className="row mb-4">
                <div className="col text-center">
                  <div className="fs-22 fw-700">Satış Talebiniz Bize Ulaştı</div>
                </div>
              </div>
              <div className="row mb-4">
                <div className="col text-center">
                  <p>
                    iyiMakina.com müşteri temsilciniz en kısa sürede sizinle iletişime geçecektir.
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <a
                    className="im-button im-button--primary im-button--fluid im-button--center"
                    onClick={() => setVideoUrl('https://www.youtube.com/embed/ZCeZBGGlVHg?autoplay=1&amp;autohide=1&amp;fs=1&amp;rel=0&amp;hd=1&amp;wmode=transparent&amp;enablejsapi=1&amp;html5=1')}
                  >
                    {t('findOutHowItWorks')}
                  </a>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <Link href="/">
                    <a className="im-button im-button--transparent im-button--fluid im-button--center">Anasayfaya Git</a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <VideoModal
        videoUrl={videoUrl}
        setVideoUrl={setVideoUrl}
      />
    </>
  );
};

Success.propTypes = {
  t: PropTypes.func,
};

export default Success;
